export default class KlevuSearchAPILayer {
  constructor () {
    this.apiKey = 'klevu-173091196240917713'
    this.endpoint = 'eucs34v2.ksearchnet.com'

    this.getUUID()
  }

  async getUUID () {
    const url = `https://stats.ksearchnet.com/analytics/uuid`

    const options = {
      method: 'POST',
      url,
      headers: {
        'Content-Type': 'application/json',
      },
    }

    const response = await fetch(url, options)
    const data = await response.json()

    sessionStorage.setItem('klevu_uuid', data.klevu_uuid)
    sessionStorage.setItem('klevu_ip_address', data.ip_address)
  }

  async fetchProducts (query) {
    const url = `https://${this.endpoint}/cs/v2/search`

    const options = {
      method: 'POST',
      url,
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        recordQueries: [
          {
            id: "productSearch",
            typeOfRequest: "SEARCH",
            settings: {
              query: {
                term: query
              },
              limit: 4,
              typeOfRecords: [
                "KLEVU_PRODUCT"
              ],
            }
          }
        ],
        context: {
          apiKeys: [this.apiKey],
        },
      }),
    }

    const response = await fetch(url, options)
    const data = await response.json()

    return data
  }

  async fetchCollections (query) {
    const url = `https://${this.endpoint}/cs/v2/search`

    const options = {
      method: 'POST',
      url,
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        recordQueries: [
          {
            id: "categorySearch",
            typeOfRequest: "SEARCH",
            settings: {
              query: {
                term: query
              },
              limit: 5,
              typeOfRecords: [
                "KLEVU_CATEGORY"
              ],
            }
          }
        ],
        context: {
          apiKeys: [this.apiKey],
        },
      }),
    }

    const response = await fetch(url, options)
    const data = await response.json()

    return data
  }

  async fetchSuggestions (query) {
    const url = `https://${this.endpoint}/cs/v2/search`

    const options = {
      method: 'POST',
      url,
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        suggestions: [
          {
            id: "mySuggestionsQuery1",
            typeOfRequest: "AUTO_SUGGESTIONS",
            query,
            limit: 5,
            hlStartElem: "<span>",
            hlEndElem: "</span>"
          },
        ],
        context: {
          apiKeys: [this.apiKey],
        },
      }),
    }

    const response = await fetch(url, options)
    const data = await response.json()

    return data
  }
}
